module.exports = __webpack_public_path__ + "static/media/NextStepLocation.eb2bd3a7.svg";